import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/dashboard/page.tsx");
